import { type optionType } from "utils";
import { localeCodes } from "i18n/locales";
import type { localeCodeType } from "i18n/types";
import { getAppConfiguration, isMemoringApp } from "appConfig";

const memoringLocales: string[] = ["hu", "en", "ro", "fr", "de"];

const jinnyLocales: string[] = [
  "en",
  "de",
  "sk",
  "es",
  "fr",
  "hu",
  "pt",
  "ro",
  "bg",
  "sr",
  "ja",
  "ee",
];

export async function getAvailableLocales(): Promise<string[]> {
  const config = await getAppConfiguration();
  return isMemoringApp(config) ? memoringLocales : jinnyLocales;
}

export async function getDefaultLocale() {
  const config = await getAppConfiguration();
  return isMemoringApp(config) ? "hu" : "en";
}

export function languageOptions(): optionType[] {
  return localeCodes.map((item: localeCodeType) => ({
    label: `language.${item.localeName}`,
    value: item.localeCode,
  }));
}
